// stores/counter.ts
import {defineStore} from 'pinia'
import {ref} from "vue";
import {NotificationEntity} from "@/entities/NotificationEntity";
import UserEntity, {MeEntity} from "@/entities/UserEntity";
import Api from "@/modules/Api/Api";
import TelegramWebApp from "@/telegram/TelegramWebApp";

export let useApiStore = defineStore('api', () => {

	let api = new Api(
		TelegramWebApp.app?.initData! || process.env.VUE_APP_FAKE_INIT_DATA,
		process.env.VUE_APP_API_BASE_URL
	);

	return {api}

});